module.exports = __webpack_public_path__ + "img/cuda.8fbf6a32.png";